<template>
  <div class="partnerIndex">
    <job-header-simple
      :header_fixed="false"
      header_title
      :left_arrow="top_left_arrow"
      :left_text="top_left_text"
    ></job-header-simple>
    <header>
      <van-image
        round
        width="1.3067rem"
        height="1.3067rem"
        fit="cover"
        :src="srcheader"
        class="header van-hairline--surround"
      />

      <div class="info">
        <p class="name">
          {{activeUserInfo.name}}
          <van-tag
            type="primary"
            style="position:relative;top:-2px;"
            @click="commissionHandle"
            v-show="userType==3"
          >团队业绩</van-tag>
        </p>
        <p class="tel">{{activeUserInfo.mobile_phone}}</p>
      </div>
    </header>
    <div class="pageMain">
      <div class="main_col_section">
        <van-row>
          <van-col :span="colSpan" @click="companyHandle">
            <div class="icon_item">
              <img src="./assets/icon_index_qiye.png" />
              <p>服务企业</p>
            </div>
          </van-col>
          <van-col :span="colSpan" @click="rechargeHandle">
            <div class="icon_item">
              <img src="./assets/icon_index_chongzi.png" />
              <p>企业充值</p>
            </div>
          </van-col>

          <van-col :span="colSpan" @click="payHandle">
            <div class="icon_item">
              <img src="./assets/icon_index_fafanjilu.png" />
              <p>发放记录</p>
            </div>
          </van-col>
          <van-col :span="colSpan" @click="applyTicket" v-if="showAplly">
            <div class="icon_item">
              <img src="./assets/icon_index_kaipiao.png" />
              <p>我要开票</p>
            </div>
          </van-col>
        </van-row>
        <van-cell
          :title="historyNumber"
          value="更多"
          label="最近一次佣金"
          is-link
          to="/partner_income_index"
        ></van-cell>
      </div>
      <div class="indexChartsSection">
        <div class="chartsHeader">
          <van-button round type="default" size="small" @click="showYears = true">{{years}}</van-button>
          <div class="stageSwitch van-hairline--surround">
            <span :class="{active: type==0? true:false}" @click="changeTimeShow(0)">年</span>
            <span :class="{active: type==1? true:false}" @click="changeTimeShow(1)">季度</span>
          </div>
        </div>

        <chart :options="myEnterOptions" chartId="myEnterChart"></chart>
        <chart :options="enterChargeOptions" chartId="enterChargeChart"></chart>
        <chart :options="monthIncreaseOptions" chartId="monthIncreaseChart"></chart>
      </div>
    </div>

    <van-popup v-model="showYears" position="bottom">
      <van-picker
        show-toolbar
        title="选择年份"
        :columns="columns"
        @cancel="showYears = false"
        @confirm="onConfirm"
        :default-index="yearIndex"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  Image,
  Cell,
  CellGroup,
  Button,
  NavBar,
  Uploader,
  Tag,
  Tab,
  Tabs,
  Row,
  Col,
  Icon,
  Popup,
  Picker
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import chart from "@/components/echarts/index.vue";
import api from "@/api/list";
import { getUserTypeCode } from "@/utils/auth";

export default {
  components: {
    [Image.name]: Image,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Uploader.name]: Uploader,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Icon.name]: Icon,
    [Col.name]: Col,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    jobHeaderSimple,
    chart
  },
  data() {
    return {
      srcheader: require("./assets/icon_index_default_user.png"),
      activeUserInfo: {},
      top_left_arrow: false,
      top_left_text: "首页",
      historyNumber: "暂无",
      years: new Date().getFullYear(),
      type: 0, //0 月(年)  1 季度
      userType: getUserTypeCode(),
      showYears: false,
      columns: [],
      colSpan: 8,
      showAplly: false,
      xAxisSeasonColumn: ["一季度", "二季度", "三季度", "四季度"],
      xAxisMonthColumn: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      activeName: "a",
      myEnterOptions: {
        title: {
          text: "我的佣金"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        series: [
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      enterChargeOptions: {
        title: {
          text: "企业充值"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        series: [
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      monthIncreaseOptions: {
        title: {
          text: "月增企业"
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: []
        },
        series: [
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      }
    };
  },
  created() {
    this.myEnterOptions.xAxis.data = this.xAxisMonthColumn;
    this.enterChargeOptions.xAxis.data = this.xAxisMonthColumn;
    this.monthIncreaseOptions.xAxis.data = this.xAxisMonthColumn;
    this.initActiveUserInfo();
    this.getLastCommission();
    this.initYears();
    this.getTrendData({ year: this.years, type: 0 });
  },
  computed: {
    yearIndex: function() {
      return this.columns.indexOf(this.years);
    }
  },
  methods: {
    getLastCommission() {
      api.getLastCommission().then(res => {
        if (res.data.data) {
          this.historyNumber = res.data.data.amount;
        }
      });
    },
    // 团队业绩
    commissionHandle() {
      this.$router.push({ path: "partner_my_achieve" });
    },
    // 服务企业
    companyHandle() {
      this.$router.push({ path: "partner_company_search" });
    },
    // 充值
    rechargeHandle() {
      this.$router.push({ path: "partner_recharge_search" });
    },
    // 发放记录
    payHandle() {
      this.$router.push({ path: "partner_pay_search" });
    },
    // 我要开票
    applyTicket() {
      this.$router.push({ path: "partner_apply_ticket" });
    },
    //确认选择年份
    onConfirm(value) {
      this.years = value;
      this.showYears = false;
    },
    initActiveUserInfo() {
      api.partnetGetActiveUserPartInfo().then(res => {
        if (res.data.status == "200") {
          this.activeUserInfo = res.data.data[0];
          if (this.activeUserInfo.type==3) {
            this.colSpan = 6;
            this.showAplly = true;
          }
          if (
            res.data.data[0].avatar &&
            typeof res.data.data[0].avatar != "undefined"
          ) {
            this.userImage.push({
              //  url:"http://183.62.139.165:85/upload/content/article/img/201911/79c25e7c-2430-4278-baff-0ba707985f50.png"
              url: process.env.VUE_APP_FILE_PATH + res.data.data[0].avatar
            });
          }
        }
      });
    },
    initYears() {
      const currentYear = this.years;
      for (let i = 0; i < 5; i++) {
        this.columns.push(currentYear - i);
      }
    },
    changeTimeShow(type) {
      // 年，季度切换
      if (type == 0) {
        // 按年显示
        this.myEnterOptions.xAxis.data = this.xAxisMonthColumn;
        this.enterChargeOptions.xAxis.data = this.xAxisMonthColumn;
        this.monthIncreaseOptions.xAxis.data = this.xAxisMonthColumn;
      } else {
        // 按季度显示
        this.myEnterOptions.xAxis.data = this.xAxisSeasonColumn;
        this.enterChargeOptions.xAxis.data = this.xAxisSeasonColumn;
        this.monthIncreaseOptions.xAxis.data = this.xAxisSeasonColumn;
      }
      this.type = type;
      this.getTrendData({ year: this.years, type: type });
    },
    getTrendData(param) {
      let trendData = sessionStorage.getItem(
        "amount_runningAmount_addCompanyNum" + param.type + "_" + param.years
      );
      if (trendData) {
        trendData = JSON.parse(trendData);
        this.myEnterOptions.series[0].data = trendData.data.data.data.amountY;
        this.enterChargeOptions.series[0].data =
          trendData.data.data.data.runningAmountY;
        this.monthIncreaseOptions.series[0].data =
          trendData.data.data.data.addCompanyNumY;
      } else {
        api.getTrendData(param).then(res => {
          this.myEnterOptions.series[0].data = res.data.data.data.amountY;
          this.enterChargeOptions.series[0].data =
            res.data.data.data.runningAmountY;
          this.monthIncreaseOptions.series[0].data =
            res.data.data.data.addCompanyNumY;
          sessionStorage.setItem(
            "amount_runningAmount_addCompanyNum" + this.type + "_" + this.years,
            JSON.stringify(res)
          );
        });
      }
    },
    base64toFile(dataurl, filename = "headPportrait") {
      let arr = dataurl.split(",");

      let mime = arr[0].match(/:(.*?);/)[1];

      let suffix = mime.split("/")[1];

      let bstr = atob(arr[1]);

      let n = bstr.length;

      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      });
    }
  }
};
</script>

<style lang="less" scoped>
.partnerIndex {
  margin-top: -1.22667rem;
  background: #8390eb;
  background: -webkit-linear-gradient(#8390eb, #f0f2f5 40%);
  background: -o-linear-gradient(#8390eb, #f0f2f5 40%);
  background: -moz-linear-gradient(#8390eb, #f0f2f5 40%);
  background: linear-gradient(#8390eb, #f0f2f5 40%);
  /deep/ .van-nav-bar {
    background: transparent;
    .van-nav-bar__text {
      font-size: 0.52rem;
      color: #fff;
    }
  }
  header {
    padding: 0.3733rem 0.3467rem;

    .header {
      display: inline-block;
      vertical-align: middle;
    }
    .info {
      display: inline-block;
      vertical-align: middle;
      margin-left: 16px;
      color: #333;
      p {
        padding: 0;
        margin: 0;
      }
      .name {
        line-height: 24px;
        font-size: 17px;
        font-weight: bolder;
      }

      .tel {
        line-height: 24px;
        font-size: 12px;
        color: #6c7ef3;
      }
    }
  }

  .pageMain {
    padding: 0 12px;
  }

  .indexChartsSection {
    position: relative;
    background: #fff;
    border-radius: 0.2667rem;
    padding-left: 10px;
    margin-bottom: 0.6667rem;

    .chartsHeader {
      padding: 12px 12px 12px 0;
      overflow: hidden;
      /deep/ .van-button {
        float: left;
      }
      .stageSwitch {
        float: right;
        color: #999;
        font-size: 12px;
        border-color: #ddd;
        span {
          display: inline-block;
          width: 40px;
          line-height: 30px;
          text-align: center;

          &.active {
            background: #8390eb;
            color: #fff;
          }
        }
      }
    }
  }

  /deep/ .van-tab {
    color: #333;
    font-size: 0.3733rem;

    &.van-tab--active {
      color: #6275f0;
    }
  }

  /deep/ .van-tabs__line {
    background-color: #6275f0;
  }

  .main_col_section {
    background: #fff;
    border-radius: 0.2667rem;
    margin-bottom: 12px;
    overflow: hidden;
    /deep/ .van-row {
      border-bottom: 1px solid #eee;
    }
    /deep/ .van-cell__title {
      font-size: 0.48rem;
      color: #6275f0;
    }
    /deep/ .van-cell__label {
      color: #666;
      font-size: 0.2933rem;
    }

    /deep/ .van-cell__right-icon {
      margin-top: 0.3rem;
    }

    /deep/ .van-cell__value {
      padding-top: 0.3rem;
    }

    .icon_item {
      text-align: center;
      color: #8390eb;
      padding: 0.48rem 0 0.32rem;
      img {
        display: block;
        width: 0.72rem;
        height: 0.72rem;
        margin: 0 auto;
      }

      p {
        font-size: 0.2933rem;
        color: #323233;
        font-weight: bolder;
        margin-top: 0.16rem;
      }
    }
  }
}
</style>


